
























import { Component, Prop, Vue } from "vue-property-decorator";

interface Bubble {
  id: number;
  left: number;
  size: number;
  rise: number;
  delay: number;
  sway: number;
  swayWidth: number;
}

// Soap bubbles that drift up behind the glass window. They sit under the page (z-index -1), so they
// never cover text, and they only exist when the OS allows motion.
@Component
export default class AeroDecor extends Vue {
  @Prop({ required: true }) readonly place!: string;

  bubbles: Bubble[] = Array.from({ length: 16 }, (_, id) => {
    const size = 16 + Math.round(Math.random() ** 2 * 84);
    const rise = 16 + Math.random() * 18 + size / 12;
    return {
      id,
      left: Math.random() * 96,
      size,
      rise,
      delay: Math.random() * rise,
      sway: 3 + Math.random() * 4,
      swayWidth: 8 + Math.random() * 22,
    };
  });
}
